<template>
    <div class="sms-broadcast-filter">
        <ds-dropdown v-if="!filter.value" position="bottom-end">
            <ds-text-button id="filter-button" leading-icon="filter">
                {{ $options.MESSAGE_CONSTANTS.FILTER }}
            </ds-text-button>

            <ul id="filter-menu" slot="menu" class="dropdown-menu-list">
                <li
                    v-for="(element, key) in filters"
                    :key="key"
                    :class="['dropdown-menu-item', { selected: element.value === filter.value }]"
                    @click="$emit('update:filter', element)"
                >
                    {{ element.label }}
                </li>
            </ul>
        </ds-dropdown>

        <ds-chip
            v-else
            remove
            with-interaction
            @click.native="$emit('update:filter', {})"
        >
            {{ filter.label }}
        </ds-chip>
    </div>
</template>

<script>
import { SMS_BROADCAST_STATUS, SMS_BROADCAST_STATUS_MESSAGE } from '../constants/smsBroadcast.constants';

export const MESSAGE_CONSTANTS = {
    FILTER: 'Filter',
    ALL: 'All',
    SENT: 'Sent',
    SCHEDULED: 'Scheduled',
    DRAFT: 'Draft',
};

export default {

    SMS_BROADCAST_STATUS,
    SMS_BROADCAST_STATUS_MESSAGE,
    MESSAGE_CONSTANTS,

    props: {
        filter: {
            type: Object,
            default: () => ({}),
            sync: true,
        },
    },

    data() {
        return {
            filters: [
                { label: MESSAGE_CONSTANTS.ALL, value: undefined },
                { label: SMS_BROADCAST_STATUS_MESSAGE.SENT, value: SMS_BROADCAST_STATUS.SENT },
                { label: SMS_BROADCAST_STATUS_MESSAGE.SCHEDULED, value: SMS_BROADCAST_STATUS.SCHEDULED },
                { label: SMS_BROADCAST_STATUS_MESSAGE.DRAFT, value: SMS_BROADCAST_STATUS.DRAFT },
                { label: SMS_BROADCAST_STATUS_MESSAGE.STOPPED, value: SMS_BROADCAST_STATUS.STOPPED },
            ],
        };
    },
};
</script>

<style lang="scss">
    div.sms-broadcast-filter ul#filter-menu {
        margin-bottom: .75rem;
        margin-top: .75rem;
        padding-bottom: 0;
        padding-top: 0;
        height: max-content;
    }

    div.sms-broadcast-filter button#filter-button > svg {
        margin-right: .3rem;
    }

    div.sms-broadcast-filter ul.dropdown-menu-list {
        margin-top: 0;
        margin-bottom: 0;
    }

    div.sms-broadcast-filter div.dropdown-menu {
        min-height: 280px;
    }

    div.sms-broadcast-filter div.menu {
        overflow: hidden;
    }
</style>
